import React from 'react';
import TemplateProyect from '../TemplateProyect';

function Yugioh() {
    const infoTect = ["React", "HTML", "CSS", "JavaScript", "Sweetalert2", "Three.js", "Blender", "", "", ""];
    const infoProyect = [
        "Learn Yugioh",
        "https://www.youtube.com/embed/4HfpsGzPils",
        "Page that gives you a little look to redirect you to a page to learn how to play the Yugioh game",
        "https://brandongrimaldom.github.io/yugioh-new-player/",
        "/web-development"
    ];

    return (
        <React.Fragment>
            <TemplateProyect
                title={infoProyect[0]}
                video={infoProyect[1]}
                description={infoProyect[2]}
                github={infoProyect[3]}
                tecfilter={infoTect}
                after={infoProyect[4]}  >
            </TemplateProyect>
        </React.Fragment>
    );
}
export default Yugioh;